import { jsx } from "react/jsx-runtime";
import { isClient, isRSC, isServer, isWeb } from "@tamagui/constants";
import * as React from "react";
import { ButtonNestingContext } from "../contexts/ButtonNestingContext";
import { TextAncestorContext } from "../contexts/TextAncestorContext";
import { useMediaListeners } from "../hooks/useMedia";
import { ThemeProvider } from "./ThemeProvider";
import { AnimationDriverContext } from "../contexts/AnimationDriverContext";
function TamaguiProvider({
  children,
  disableInjectCSS,
  config,
  ...themePropsProvider
}) {
  if (isRSC) {
    return /* @__PURE__ */ jsx(
      "span",
      {
        style: { display: "contents" },
        className: `t_${Object.keys(config.themes)[0] || "light"}`,
        children
      }
    );
  }
  if (!(isWeb && isServer)) {
    useMediaListeners(config);
  }
  if (isClient) {
    React.useLayoutEffect(() => {
      if (document.documentElement.classList.contains("t_unmounted")) {
        document.documentElement.classList.remove("t_unmounted");
      }
      if (disableInjectCSS)
        return;
      const style = document.createElement("style");
      style.appendChild(document.createTextNode(config.getCSS()));
      document.head.appendChild(style);
      return () => {
        document.head.removeChild(style);
      };
    }, [config, disableInjectCSS]);
  }
  return /* @__PURE__ */ jsx(ButtonNestingContext.Provider, { value: false, children: /* @__PURE__ */ jsx(TextAncestorContext.Provider, { value: false, children: /* @__PURE__ */ jsx(AnimationDriverContext.Provider, { value: config.animations, children: /* @__PURE__ */ jsx(
    ThemeProvider,
    {
      themeClassNameOnRoot: config.themeClassNameOnRoot,
      disableRootThemeClass: config.disableRootThemeClass,
      ...themePropsProvider,
      defaultTheme: themePropsProvider.defaultTheme ?? Object.keys(config.themes)[0],
      children
    }
  ) }) }) });
}
export {
  TamaguiProvider
};
//# sourceMappingURL=TamaguiProvider.js.map
